

































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly fetchReportProvider!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly providerName!: string;

  utilsInstance = utils;

  onClickProviderName(provider, name) {
    this.fetchReportProvider(provider, name);
  }
}
